import React, { useState, useEffect } from 'react';
import {
  Add, Remove
} from "@mui/icons-material";

import { 
  Character,
} from "@dndModels";

import API from "@dndUtilities/system_api";

import CheckBoxes from "@components/input/CheckBoxes";
import ButtonBox from '@components/input/buttons/ButtonBox';

interface Props {
  used: number;
  total: number;
  true_total: number;
  created: number;
  onChange: (used: number) => void;
  onLabelClick?: () => void;
  character?: Character | null;
  type?: string;
  show_type?: boolean;
  label?: React.ReactNode;
  threshold?: number;
  flat?: boolean;
  lineHeight?: number;
  marginLeft?: number;
  shared: boolean;
  disabled?: boolean;
  show_reset?: boolean;
}

const api = API.getInstance();

export default function CharacterResourceBoxes({ 
  used,
  total,
  true_total,
  created,
  onChange,
  onLabelClick,
  character = null,
  type = "",
  show_type = true,
  label = "",
  threshold = 6,
  flat = false,
  lineHeight = 0.5,
  // marginLeft,
  shared,
  disabled = false,
  show_reset = false
}: Props) {
  const [my_used, setUsed] = useState(used);
  const [my_total, setTotal] = useState(total);
  const [my_true_total, setTrueTotal] = useState(true_total);
  const [my_created, setCreated] = useState(created);
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  useEffect(() => {
    if (used !== my_used) {
      setUsed(used);
    }
    // eslint-disable-next-line
  }, [used]);
  useEffect(() => {
    if (total !== my_total) {
      setTotal(total);
    }
    // eslint-disable-next-line
  }, [total]);
  useEffect(() => {
    if (true_total !== my_true_total) {
      setTrueTotal(true_total);
    }
    // eslint-disable-next-line
  }, [true_total]);
  useEffect(() => {
    if (created !== my_created) {
      setCreated(created);
    }
    // eslint-disable-next-line
  }, [created]);
  
  const updateCharacter = (new_used: number) => {
    if (!type.includes("Created")) {
      setUsed(new_used);
    }
    onChange(new_used);
  }

  const enabled = shared || (api.user && (character === null || character.owner_id === api.user._id || (character.campaign && character.campaign.owner_id === api.user._id)));
  const return_me: any[] = [];
  if (reloading) {
    return <></>;
  }
  if (my_total > threshold) {
    if (label !== "") {
      return_me.push(
        <span key="label" style={{ lineHeight: `${lineHeight}` }}>
          { label }
        </span>
      );
    }
    if (!disabled) {
      return_me.push(
        <span key="add">
          <Remove
            style={{
              cursor: (enabled ? "pointer" : "inherit")
            }}
            onClick={() => {
              if (my_used > 0 && enabled) {
                updateCharacter(my_used - 1);
                if (type.includes("Created")) {
                  setReloading(true);
                }
              }
            }}
          />
        </span>
      );
    }
    if (my_created > 0) {
      return_me.push(
        <span key="created"
          style={{
            fontWeight: "bold",
            fontSize: "15px",
            cursor: "pointer"
          }}
          onClick={() => {
            
          }}>
          { my_total - my_used }/({ my_true_total }+{ my_created })
        </span>
      );
    } else {
      return_me.push(
        <span key="created"
          style={{
            fontWeight: "bold",
            fontSize: "15px",
            cursor: "pointer"
          }}
          onClick={() => {
            
          }}>
          { my_used }/{ my_true_total }
        </span>
      );
    }
    if (!disabled) {
      return_me.push(
        <span key="remove">
          <Add
            style={{
              cursor: (enabled ? "pointer" : "inherit")
            }}
            onClick={() => {
              if (enabled && my_used < my_total) {
                updateCharacter(my_used + 1);
                if (type.includes("Created")) {
                  setReloading(true);
                }
              }
            }}
          />
        </span>
      );
    }
    if (show_type) {
      return_me.push(
        <span key="slot_name">
          { type }&nbsp;
        </span>
      );
    }
  } else {
    return_me.push(
      <CheckBoxes key="checkboxes"
        name={ show_type ? type : label }
        name_first={ !show_type && label !== "" }
        value={my_used}
        total={my_total}
        disabled={!enabled || disabled}
        onChange={(changed: number) => {
          updateCharacter(changed);
          if (type.includes("Created")) {
            setReloading(true);
          }
        }}
        onLabelClick={onLabelClick}
      />
    );
  }
  if (flat) {
    return (
      <>
        { return_me }
        { show_reset && 
          <ButtonBox 
            name="Reset"
            onClick={() => updateCharacter(0)}
          />
        }
      </>
    );
  } else {
    return (
      <span style={{ 
        display: "inline-flex", 
        // marginLeft: (marginLeft === undefined ? "20px" : `${marginLeft}px`), 
        width: "100%" 
      }}>
        { show_reset ? 
          <>
            <span style={{ flex: "0 0 50%" }}>{ return_me }</span>
            <span style={{ flex: "0 0 50%" }}>
              { show_reset && 
                <ButtonBox 
                  name="Reset"
                  onClick={() => updateCharacter(0)}
                />
              }
            </span>
          </>
        : return_me }
      </span>
    );
  }
}
